import KeyboardHandler from 'dompack/extra/keyboard';
module.exports = KeyboardHandler;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/system/nodejs/dom/keyboard.es